import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Navbar from './components/Navbar';
import Home from './pages/Home';

import Login from './admin/Login';
import Dashboard from './admin/Dashboard';
import POSBilling from './admin/POSBilling';
import Inventory from './admin/Inventory';
import Reports from './admin/Reports';
import UserManagement from './admin/UserManagement';
import GalleryManagement from './admin/GalleryManagement';
import EnquiryManagement from './admin/EnquiryManagement';
import SiteSettings from './admin/SiteSettings';


import POS from './cashier/POS';

const ProtectedRoute = ({ element, allowedRoles }) => {
  const token = localStorage.getItem('csk_token');
  const user = JSON.parse(localStorage.getItem('csk_user') || '{}');
  if (!token) return <Navigate to="/login" />;
  if (allowedRoles && !allowedRoles.includes(user.role)) {
    if (user.role === 'cashier') return <Navigate to="/cashier/pos" />;
    return <Navigate to="/admin/dashboard" />;
  }
  return element;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Public — Single Page */}
        <Route path="/" element={<><Navbar /><Home /></>} />

        {/* Auth */}
        <Route path="/login" element={<Login />} />

        {/* Admin + Manager */}
        <Route path="/admin/dashboard" element={<ProtectedRoute element={<Dashboard />} allowedRoles={['admin', 'manager']} />} />
        <Route path="/admin/inventory" element={<ProtectedRoute element={<Inventory />} allowedRoles={['admin', 'manager']} />} />
        <Route path="/admin/reports" element={<ProtectedRoute element={<Reports />} allowedRoles={['admin', 'manager']} />} />
        <Route path="/admin/gallery" element={<ProtectedRoute element={<GalleryManagement />} allowedRoles={['admin', 'manager']} />} />
        <Route path="/admin/enquiries" element={
          <ProtectedRoute element={<EnquiryManagement />} allowedRoles={['admin', 'manager']} />
        } />
        <Route path="/admin/settings" element={
        <ProtectedRoute element={<SiteSettings />} allowedRoles={['admin']} />
      } />
      

        {/* Admin Only */}
        <Route path="/admin/pos" element={<ProtectedRoute element={<POSBilling />} allowedRoles={['admin']} />} />
        <Route path="/admin/users" element={<ProtectedRoute element={<UserManagement />} allowedRoles={['admin']} />} />

        {/* Cashier */}
        <Route path="/cashier/pos" element={<ProtectedRoute element={<POS />} allowedRoles={['cashier']} />} />

        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
}

export default App;
